
(() => {
  if (window.bywPromotionsInitialized) return;
  window.bywPromotionsInitialized = true;
  const opens = Date.parse('2026-10-15T06:00:00Z');
  const closes = Date.parse('2026-12-16T06:59:00Z');
  const update = () => {
    const now = Date.now();
    document.querySelectorAll('[data-byw-promo]').forEach(element => {
      element.hidden = element.dataset.editor !== 'true' && !(now >= opens && now < closes);
    });
  };
  update();
  window.setInterval(update, 1000);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', update);
})();
